import { useTranslation } from "react-i18next";

import type { CourseAdmission } from "@/api";
import { admissionTone } from "@/lib/admission";

import { StatusPill } from "../status-pill";

const TONE_TO_PILL = {
  success: "success",
  warning: "warning",
  live: "live",
  neutral: "neutral",
} as const;

/**
 * Qabul holati: "Qabul ochiq · 3 ta joy qoldi", "Qabul to'xtatilgan".
 * Holatni server hisoblaydi — nishon faqat ko'rsatadi.
 */
export const AdmissionPill = ({ admission }: { admission: CourseAdmission }) => {
  const { t } = useTranslation();
  const seats =
    admission.state === "OPEN" && admission.seatsLeft !== null
      ? ` · ${t("ADMISSION.SEATS_LEFT", { count: admission.seatsLeft })}`
      : "";
  return (
    <StatusPill
      tone={TONE_TO_PILL[admissionTone(admission.state, admission.seatsLeft)]}
      label={`${t(`ADMISSION.STATE_${admission.state}`)}${seats}`}
    />
  );
};
